import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useLocation } from "@reach/router";

import favIcon from "../images/favicon.ico";
import defaultImage from "../images/preview.jpg";

const Seo = ({ title, description, children }) => {
  const data = useStaticQuery(graphql`
    query SiteData {
      site {
        siteMetadata {
          title
          siteUrl
          description
          author
          keywords
        }
      }
    }
  `);

  const {
    title: defaultTitle,
    description: defaultDescription,
    author: defaultAuthor,
    keywords,
    siteUrl,
  } = data.site.siteMetadata;

  const path = useLocation();

  let pageTitle = defaultTitle;
  if (title) {
    pageTitle = `${title} - ${defaultTitle}`;
  }

  const seo = {
    title: pageTitle || defaultTitle,
    description: description || defaultDescription,
    keywords: keywords,
    author: defaultAuthor,
    url: `${siteUrl}${path.pathname || ``}`,
    image: `${siteUrl}${defaultImage}`,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name='description' content={seo.description} />
      <meta name='keywords' content={seo.keywords} />
      <meta name='author' content={seo.author} />
      <meta name='image' content={seo.image} />

      <meta property='og:title' content={seo.title} />
      <meta property='og:description' content={seo.description} />
      <meta property='og:image' content={seo.image} />
      <meta property='og:url' content={seo.url} />
      <meta property='og:type' content='website' />

      <meta name='twitter:title' content={seo.title} />
      <meta name='twitter:description' content={seo.description} />
      <meta name='twitter:image' content={seo.image} />
      <meta name='twitter:card' content='summary_large_image' />

      <link rel='icon' href={favIcon} type='image/x-icon' />

      <link rel='canonical' href={seo.url} />

      <script type='application/ld+json'>
        {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "url": "${seo.url}",
            "name": "${seo.title}",
            "description": "${seo.description}",
            "image": "${seo.image}"
          }
        `}
      </script>

      {children}
    </>
  );
};

export default Seo;
